import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHtml',
  standalone: false,
})
export class RemoveHtmlPipe implements PipeTransform {
  transform(input: string): any {
    if (!input) {
      return input;
    }
    return input.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
  }
}
